export default "__VITE_ASSET__C3ilqW97__"